import classnames from 'classnames';
import * as geojson from 'geojson';
import React from 'react';

import * as geoJsonUtils from 'app/utils/geoJsonUtils';

import cs from './styles.module.scss';

export interface Props {
  geometry: geojson.Geometry | null | undefined;
  significantDigits?: number;
  // Rendered when the geometry has no representable center, so callers can keep
  // their own wording for "no location".
  fallback?: React.ReactNode;
  className?: string;
}

// Inline form: "Lat: 30.26720, Long: -97.74690". The map popup stacks the two
// on separate lines instead; everywhere else stays inline so existing layouts
// and the exported PDF's pagination don't shift.
export const CoordinateDisplay: React.FunctionComponent<Props> = ({
  geometry,
  significantDigits,
  fallback = null,
  className,
}) => {
  const parts = geoJsonUtils.makeCoordinateParts(geometry ?? null, significantDigits);

  if (!parts) {
    return <>{fallback}</>;
  }

  return (
    <span className={classnames(cs.coordinateDisplay, className)}>
      <span className={cs.coordinatePart}>Lat: {parts.lat},</span>{' '}
      <span className={cs.coordinatePart}>Long: {parts.lng}</span>
    </span>
  );
};
